export const RESTORE_FOCUS_TIMEOUT = 100



//////////////////
// WEBPACK FOOTER
// ./node_modules/sweetalert2/src/constants.js
// module id = null
// module chunks = 